





















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Cover extends Vue {
  @Prop() private title!: string
  @Prop() private subtitle!: string
  @Prop() private imgClass!: string
  @Prop() private imgPosition!: string
}
